import handleEventMap from '../common/handleEventMap';
import handleToggleByIndex from '../common/handleToggleByIndex';
import handleInit from './handleInit';

/**
 * Attach interactions to every element that matches selector.
 */
$('.tabs').each((_, component) => {
    const $tabItems = $(component).find('.tabs__item');
    const $contents = $(component).find('.tabs__content');

    $tabItems.each((index, item) => {
        // toggle tab contents based on clicked tab item
        $(item)
            .on('click', handleToggleByIndex($tabItems, index))
            .on('click', handleToggleByIndex($contents, index))
            .on('click', handleEventMap(component, 'tabs:select', () => index));
    });

    $(window).on('load', handleInit(component));
});



// WEBPACK FOOTER //
// ./src/scripts/components/tabs/index.js